import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { useQuery, useMutation } from '@apollo/client';
import omitDeep from 'Util/omitDeep';

import { getWorkshopDescription } from 'src/GraphQL/query/Workshop.query';
import { sfUpdateWorkshop } from 'src/GraphQL/mutation/Workshop.mutation';
import Loading from 'Components/Loading';
import ErrorView from 'Components/ErrorView';
import CheckMutationResponse from 'Containers/CreateEditForm/Components/CheckMutationResponse';

import delve from 'Util/Delve';
import { MarkupTextInput } from '../../Components/MarkupTextInput';

const WorkshopDescription = ({ skuCode }) => {
  const { loading, error, data: queryData } = useQuery(getWorkshopDescription, {
    variables: { SKUCode: skuCode },
    fetchPolicy: 'network-only',
  });

  const [
    updateWorkshop,
    { data: mutationResponse, loading: mutationLoading, error: mutationError },
  ] = useMutation(sfUpdateWorkshop);

  const handleUpdate = (data) => {
    const clonedData = JSON.parse(JSON.stringify(data));
    const formatData = omitDeep(clonedData, ['id', '__typename', 'assetUrl']);
    const updatedData = delve(formatData, 'content') ? formatData : null;
    updateWorkshop({
      variables: {
        SKUCode: skuCode,
        data: {
          details: updatedData,
        },
      },
    });
  };

  if (loading) return <Loading dimmer={false} loaderProps={{ active: true, inline: 'centered' }} />;
  const details = delve(queryData, 'sfWorkshopBySKUCode.details', '');

  return (
    <Fragment>
      {error && <ErrorView message={error} />}
      {mutationError && <ErrorView message={mutationError} />}
      <CheckMutationResponse
        checkOnlyDefined={false}
        response={delve(mutationResponse, 'sfUpdateWorkshop')}
        loading={mutationLoading}
        error={mutationError}
        notificationTime={2000}
      />
      <MarkupTextInput
        skuCode={skuCode}
        loading={mutationLoading}
        value={details}
        onUpdate={handleUpdate}
      />
    </Fragment>
  );
};

WorkshopDescription.propTypes = {
  skuCode: PropTypes.string.isRequired,
};

WorkshopDescription.defaultProps = {};

export default WorkshopDescription;
